<div class="list-items" [ngStyle]="{ width: dropdown.width + 'px', top: dropdown.top + 'px', left: dropdown.left + 'px' }" [hidden]="dropdown.hidden">
  @if (dropdown.filteredList.length == 0) {
    <div class="list-item out-of-focus">{{ 'general.no-results' | translate }}</div>
  }
  @for (item of dropdown.filteredList; track item.value) {
    <div
      title="{{ item.name }}"
      [item]="item"
      [ngClass]="{ highlight: item.highlight }"
    class="list-item">{{ item.name }}</div>
  }
</div>
